import {
  Box,
  Button,
  InputAdornment,
  MenuItem,
  MenuProps,
  Select,
  SelectChangeEvent,
  SxProps,
  Typography,
} from '@mui/material';
import React, { ChangeEvent, ReactNode, useState } from 'react';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
import { IconWrapper } from '../../elements/IconWrapper/Index';

const styles: IStyles = {
  selectContainer: {
    width: { xs: '100%', md: pxTovW(230) },
    height: { xs: 'max-content', md: pxTovW(75) },
    background: '#DAF5FF',
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: '#61BAFF',
      top: 0,
      legend: {
        display: 'none',
      },
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#61BAFF',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#61BAFF',
    },
    '&:focus-visible .MuiOutlinedInput-notchedOutline': {
      borderColor: '#61BAFF',
    },
    borderRadius: { xs: pxToRem(5), md: pxTovW(15) },
    fontSize: { xs: pxToRem(14), md: pxTovW(21) },
    fontWeight: '500',
    '&.Mui-disabled': {
      backgroundColor: '#D5D3D3',
    },
  },
  clearButton: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    padding: 0,
  },
};

interface IOptionList {
  name: string | number;
  id: number | bigint;
  nonEditableItem?: boolean;
  selectedNumber?: number;
  checked?: boolean;
}
interface IProps {
  placeholder?: string;
  value: string;
  optionList: IOptionList[];
  onChange: (value: string) => void;
  onClick?: () => void;
  disabled?: boolean;
  clearIcon?: boolean;
  rootStyles?: SxProps;
  parentStyles?: SxProps;
  menuItemStyles?: SxProps;
  menuPaperProps?: SxProps;
  iconComponent?: React.ElementType<any>;
  nofocus?: boolean;
  background?: string;
  selectedBold?: boolean;
  renderValue?: (selected: string, placeholder?: string) => React.ReactNode;
  menuNode?: ReactNode;
  customAdornment?: ReactNode;
  menuProps?: Partial<MenuProps>;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  dataId?: string;
}

export const SelectMenu = (props: IProps) => {
  const {
    placeholder,
    value,
    optionList,
    onChange,
    onClick,
    disabled,
    rootStyles,
    menuItemStyles,
    menuPaperProps,
    clearIcon,
    iconComponent,
    nofocus,
    background,
    renderValue,
    selectedBold,
    parentStyles,
    menuNode,
    customAdornment,
    menuProps,
    inputProps,
    dataId,
  } = props;
  const [isFocused, setIsFocused] = useState(false);
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  const handleClear = () => {
    onChange('');
  };

  let rootSx = { ...styles.selectContainer };
  if (rootStyles) rootSx = { ...rootSx, ...rootStyles };

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        ...parentStyles,
      }}
    >
      <Select
        data-id={dataId}
        inputProps={inputProps}
        IconComponent={iconComponent}
        disabled={disabled ? true : false}
        displayEmpty
        notched={false}
        value={value}
        onChange={(e, i) => {
          handleChange(e);
          // console.log('Selected value:', e.target.value, 'Selected index:', i);
        }}
        onClick={onClick}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        // endAdornment={
        //   clearIcon &&
        //   value !== '' && (
        //     <InputAdornment
        //       sx={{
        //         marginRight: { xs: pxToRem(15), md: pxTovW(30) },
        //         marginTop: '5px',
        //         pointerEvents: 'none', // 👈 Important: Let clicks pass through adornment
        //       }}
        //       position="end"
        //     >
        //       <Box
        //         sx={{
        //           cursor: 'pointer',
        //           pointerEvents: 'auto', // 👈 Enable pointer only on icon
        //         }}
        //         onClick={handleClear}
        //       >
        //         {value !== '' && (
        //           <IconWrapper
        //             name="white_x_in_gray"
        //             size="md"
        //             parentFolder="icons"
        //             type="png"
        //           />
        //         )}
        //       </Box>
        //     </InputAdornment>
        //   )
        // }
        // renderValue={(selected) => {
        //   if (value === '') {
        //     return <em>{placeholder}</em>;
        //   } else {
        //     return selected;
        //   }
        // }}
        renderValue={(selected) => {
          if (renderValue) {
            return renderValue(selected, placeholder);
          }
          return selected === '' ? (
            <em
              style={{
                fontFamily: ' Lato',
                fontStyle: 'normal',
              }}
            >
              {placeholder}
            </em>
          ) : (
            // <Box
            //   sx={{
            //     width: '95%',
            //     whiteSpace: 'nowrap',
            //     overflow: 'hidden',
            //     textOverflow: 'ellipsis',
            //     fontWeight: selectedBold ? 'bold' : 'unset',
            //   }}
            // >
            //   {selected}
            // </Box>
            <Box
              sx={{
                // whiteSpace: 'nowrap',
                // overflow: 'hidden',
                // textOverflow: 'ellipsis',
                // fontWeight: selectedBold ? 'bold' : 'unset',
                boxSizing: 'border-box',
                width: clearIcon && value !== '' ? '92%' : '100%',
                minWidth: 0,
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: { xs: pxToRem(5), md: pxTovW(10) },
                height: '100%',
              }}
            >
              {/* <Typography
                variant="h4"
                color="initial"
                sx={{
                  fontSize: { xs: pxToRem(12), md: pxTovW(16) },
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontWeight: selectedBold ? 'bold' : 'unset',
                }}
              >
                {selected}
              </Typography> */}

              <span
                style={{
                  minWidth: 0,
                  flex: '1 1 0',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  fontWeight: selectedBold ? 'bold' : 'unset',
                }}
              >
                {selected}
              </span>

              {customAdornment ? (
                <Box sx={{ flexShrink: 0 }}>{customAdornment}</Box>
              ) : (
                <Box></Box>
              )}
            </Box>
          );
        }}
        // endAdornment={
        //   clearIcon && value ? (
        //     <InputAdornment position="end">
        //       <IconButton
        //         aria-label="clear selection"
        //         onClick={handleClear}
        //         sx={{ padding: 0 }}
        //       >
        //         <CloseIcon />
        //       </IconButton>
        //     </InputAdornment>
        //   ) : null
        // }
        sx={{
          ...rootSx,
          minWidth: 0,
          maxWidth: '100%',
          '& .MuiSelect-select': {
            minWidth: 0,
            overflow: 'hidden',
          },
          boxShadow: background
            ? 'none'
            : isFocused
            ? `inset 0 0 1px 0 #61BAFF, inset 0 0 2px 1px rgba(97, 186, 255, 0.6), inset 0 0 3px 2px rgba(97, 186, 255, 0.4), inset 0 0 4px 3px rgba(97, 186, 255, 0.2), inset 0 0 5px 4px rgba(97, 186, 255, 0.1)`
            : 'none',
          // '.MuiSelect-icon': value && clearIcon ? { display: 'none' } : {}, // Hide the dropdown icon when a value is selected
        }}
        MenuProps={{
          ...menuProps,
          PaperProps: {
            sx: {
              maxHeight: { xs: pxToRem(150), md: pxTovW(300) },
              minHeight: { xs: 'max-content', md: 'max-content' },
              backgroundColor: background ? background : '#F8FCFF',
              '&::-webkit-scrollbar': { display: 'none' },
              padding: 0,
              borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
              '& .MuiList-root': {
                backgroundColor: background ? background : '#F8FCFF',
                maxHeight: { xs: pxToRem(150), md: pxTovW(300) },
                padding: 0,
              },
              scrollbarWidth: 'thin',
              minWidth: { xs: '95%', md: pxTovW(230) },
              maxWidth: { xs: '95%', md: pxTovW(200), lg: pxTovW(150) },
              ...menuPaperProps,
            },
          },
        }}
      >
        {menuNode
          ? menuNode
          : optionList.map((e) => (
              <MenuItem
                key={e.id.toString()}
                disabled={e.nonEditableItem ? true : false}
                sx={{
                  borderBottom: background
                    ? '1px solid #D5D3D3'
                    : '1px solid #96FFC5',
                  wordBreak: 'break-word',
                  // height: { xs: pxToRem(30), md: pxTovW(52) },
                  '&:last-child': { borderBottom: 'none' },
                  '&:hover': { background: background ? '#D5D3D3' : '#ECFFF5' },
                  ...menuItemStyles,
                }}
                value={e.name}
              >
                <Typography
                  data-id={
                    dataId
                      ? `${dataId}-${e.name
                          .toString()
                          .toLowerCase()
                          .replace(/\s+/g, '-')}`
                      : undefined
                  }
                  sx={{
                    textOverflow: 'ellipsis',
                    whiteSpace: 'normal',
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    fontWeight:
                      selectedBold && e.name === value ? 'bold' : 'unset',
                  }}
                >
                  {e.selectedNumber ? `${e.selectedNumber}. ${e.name}` : e.name}
                </Typography>
              </MenuItem>
            ))}
      </Select>

      {clearIcon && value !== '' && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            right: { xs: pxToRem(30), md: pxTovW(74), lg: pxTovW(42) }, // shift it slightly left of dropdown arrow
            // mt: { xs: pxToRem(-10), md: pxTovW() },
            mt: { xs: pxToRem(4), md: pxTovW(2), lg: pxTovW(5) },
            transform: 'translateY(-50%)',
            cursor: 'pointer',
          }}
          onClick={handleClear}
        >
          <IconWrapper
            name="white_x_in_gray"
            size="md"
            parentFolder="icons"
            type="png"
          />
        </Box>
      )}
    </Box>
  );
};
